import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
interface PublicRouteProps {
  children: React.ReactNode;
}

export const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return null;
  }

  // Redirect to target or home if user is already logged in
  if (user) {
    const searchParams = new URLSearchParams(window.location.search);
    const redirectTo = searchParams.get('redirect');
    return <Navigate to={redirectTo || "/home"} replace />;
  }

  return <>{children}</>;
};
